<template>
  <div class="change-password-modal">
    <div class="my-7 d-flex flex-column gap-5">
      <bp-input
        password
        v-model="form.oldPassword"
        label="Senha atual"
        placeholder="Digite sua senha atual"
      />
      <bp-input
        password
        v-model="form.newPassword"
        label="Nova senha (min. 6 caracteres)"
        placeholder="Digite sua nova senha"
        @blur="checkPasswords"
      />
      <bp-input
        password
        v-model="form.confirmPassword"
        label="Confirmar senha"
        placeholder="Confirme sua nova senha"
        :errors="errors.confirmPassword"
        @blur="checkPasswords"
      />
    </div>
    <div class="d-flex flex-column flex-lg-row justify-content-lg-end gap-3">
      <bp-button
        label="Salvar"
        class="order-lg-1"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
      <bp-button
        color="neutral"
        label="Cancelar"
        variant="filled-1"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
export default {
  data() {
    return {
      ...formFields(["oldPassword", "newPassword", "confirmPassword"])
    };
  },
  computed: {
    isValid() {
      return (
        this.form.oldPassword &&
        this.form.newPassword &&
        this.form.newPassword.length >= 6 &&
        this.form.confirmPassword &&
        this.form.newPassword == this.form.confirmPassword
      );
    }
  },
  methods: {
    submit() {
      this.loading = true;
      let data = { ...this.form };
      delete data.confirmPassword;
      this.$store
        .dispatch("user/updatePassword", data)
        .then(() => {
          this.$message.success("Senha alterada com sucesso");
          this.$emit("close");
        })
        .catch(e => {
          const msg = e.response.data?.message[0] || "Erro ao alterar senha";
          this.$message.error(msg);
        })
        .finally(() => (this.loading = false));
    },
    checkPasswords() {
      if (this.form.newPassword && this.form.confirmPassword) {
        if (this.form.newPassword != this.form.confirmPassword) {
          this.errors.confirmPassword = ["As senhas não coincidem"];
        }
      }
    }
  }
};
</script>
